/**
 * Normalizes a placeholder token name for case-insensitive, diacritic-insensitive
 * comparison during substitution and token detection.
 *
 * Applies lowercase and Unicode NFD diacritic stripping to the token name only.
 * Variable values substituted into messages must not pass through this function.
 *
 * Accented characters are decomposed and their combining marks removed, so
 * `{Título}` and `{titulo}` both normalize to `titulo`.
 */
export function normalizeTokenName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
